const URI = "https://www.d3rriana.com/share/";
export default {
  data() {
    return {
      popupText: "Copy to clipboard"
    };
  },
  methods: {
    shareToFacebook(path, slug) {
      window.FB.ui(
        {
          method: "share",
          href: `${URI}${path}${slug}`
        },
        function(response) {}
      );
    },
    shareToTwitter(path, slug) {
      var shareURL = "http://twitter.com/share?";
      var params = {
        url: `${URI}${path}${slug}`,
        text: this.title
      };
      for (var prop in params)
        shareURL += "&" + prop + "=" + encodeURIComponent(params[prop]);
      window.open(
        shareURL,
        "",
        "left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    },
    shareToLinkedin(path, slug) {
      var url = `${URI}${path}${slug}`;
      var title = this.title;
      window.open(
        "http://www.linkedin.com/shareArticle?mini=true&url=" +
          encodeURIComponent(url),
        "",
        "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    },
    copytoClipboard(path, slug) {
      navigator.clipboard.writeText(`${URI}${path}${slug}`);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    }
  }
};
